import React,{useEffect} from "react";

const External = (props) => {
  useEffect(() => {
    document.title = "External Links"
 }, []);
  let mycolor = "#A3BAC6";
  if (props.color !== mycolor) props.backColor(mycolor);
  return (
    <div
      style={{
        marginLeft: "30px",
        marginTop: "30px",
      }}
    >
      <div className="ui massive header">
        <h1 style={{ fontSize: "35px", color: "darkblue" }}>
          External Links🔗🔗
        </h1>
      </div>
      <div>
        <div className="ui padded vertical segment link">
          <span>
            <i
              className="fab fa-linkedin"
              style={{ fontSize: "60px", marginRight: "20px" }}
            ></i>
            <a
              className="ui header link"
              href="https://www.linkedin.com/in/saksham14/"
              target="_blank"
              title="Click ME!"
            >
              Linkedin
            </a>
          </span>
        </div>
        <div className="ui padded vertical segment">
          <span>
            <i
              className="fab fa-github"
              style={{ fontSize: "60px", marginRight: "20px" }}
            ></i>
            <a
              className="ui header link"
              href="https://github.com/saksham1998"
              target="_blank"
              title="Click ME!"
            >
              Github
            </a>
          </span>
        </div>
        <div className="ui padded vertical segment">
          <span>
            <i
              className="fab fa-hackerrank"
              style={{ fontSize: "60px", marginRight: "20px" }}
            ></i>
            <a
              className="ui header link"
              href="https://www.hackerrank.com/saksham_14"
              target="_blank"
              title="Click ME!"
            >
              Hackerrank
            </a>
          </span>
        </div>
        <div className="ui padded vertical segment">
          <span>
            <i
              className="fas fa-rss-square"
              style={{ fontSize: "60px", marginRight: "20px" }}
            ></i>
            <a className="ui header link" href="/" title="Click ME!">
              Blog<sub> Coming Soon</sub>
            </a>
          </span>
        </div>
      </div>
    </div>
  );
};

export default External;
